import React from 'react'

import { Box, Text, useBreakpoint } from '@factorialco/deprecated-design-system'
import { F0AvatarEmoji } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { reward } from '../helpers'

interface FooterPerkItemProps {
  emoji: string
  title: string
  description: string
}

const FooterPerkItem = ({ emoji, title, description }: FooterPerkItemProps) => {
  const { isMobile } = useBreakpoint()
  return (
    <Box flexDirection="row" gap="s24" style={{ flex: '1', width: 'full' }}>
      <F0AvatarEmoji emoji={emoji} size="lg" />
      <Box gap="s4" flexDirection="column">
        <Text weight="semibold" size="300" color="black">
          {title}
        </Text>
        <Box style={{ maxWidth: isMobile ? '350px' : '500px' }}>
          <Text size="300" color="grey1000" className="text-f1-foreground-secondary">
            {description}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

interface FooterPerksProps {
  isoCountryCode: string
}

const FooterPerks: React.FC<FooterPerksProps> = ({ isoCountryCode }) => {
  const { breakpoint } = useBreakpoint()
  const isSmallScreen = breakpoint === 's'
  const isMediumScreen = breakpoint === 'm'
  const isLargeScreen = breakpoint === 'l'
  return (
    <Box
      style={{
        flex: '3',
      }}
    >
      <Box flexDirection="column" gap="s32" style={{ width: 'full' }}>
        <FooterPerkItem
          emoji="💸"
          title={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.perk_company.title',
            {
              max_discount: reward(isoCountryCode, '1'),
            }
          )}
          description={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.perk_company.subtitle',
            {
              max_discount: reward(isoCountryCode, '1'),
            }
          )}
        />
        <FooterPerkItem
          emoji="🤝"
          title={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.perk_discount.title'
          )}
          description={i18n.t(
            'company_settings.general.factorial_referral_program.revamp.perk_discount.subtitle'
          )}
        />
      </Box>
    </Box>
  )
}

export default FooterPerks
